import React from 'react'
import FeatureMap from '../../elem/map/Map'

const DisclosureOverview = ({ overviewData, loading }) => {
    return (
        <div id="disclosure_content">
            <div className="disclosure_details">
                <p className="disc_title">
                    Disclosure(s) for {overviewData.WellName}
                </p>
                <p className="subtext">
                    Operated by {overviewData.OperatorClean}
                </p>
                <p className="subtext">API: {overviewData.APINumber}</p>
                <table className="welltable" cellSpacing="{0}">
                    <tbody>
                        <tr>
                            <th>State</th>
                            <th>County</th>
                            <th>Indian Well</th>
                            <th>Federal Well</th>
                        </tr>
                        <tr>
                            <td>{overviewData.StateName.toString()}</td>
                            <td>{overviewData.CountyName.toString()}</td>
                            <td>
                                {overviewData.IndianWell === 'true'
                                    ? 'Yes'
                                    : 'No'}
                            </td>
                            <td>
                                {overviewData.FederalWell === 'true'
                                    ? 'Yes'
                                    : 'No'}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="details_map">
                <FeatureMap
                    lat={overviewData.Latitude}
                    lon={overviewData.Longitude}
                    loading={loading}
                />
            </div>
        </div>
    )
}

export default DisclosureOverview
